// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"f40dbbf8","488":"c4e6a1c7","557":"4b23f724","558":"27865f8e","725":"b302a83c","815":"7c1e06a9","856":"8a2d7f71","985":"76ed3196"}[chunkId] + ".chunk.js";
};